// import images
import Eurovia from "../../assets/svg/eurovia.svg";
import Hermes from "../../assets/svg/hermes.svg";
import IdelExpert from "../../assets/svg/idel-expert.svg";
import MadocSante from "../../assets/svg/madoc-sante.svg";
import CfaSante from "../../assets/svg/cfa-sante.svg";
import Bimini from "../../assets/svg/bimini.svg";
import Gaby from "../../assets/svg/gaby.svg";
import ScrollAnimation from "./animations/ScrollAnimation";

const CollabHome = () => {
  return (
    <section className="my-20">
      {/* div main */}
      <div>
        {/* div titles */}
        <div className="pl-8 mb-12 lg:text-center lg:mb-28">
          <ScrollAnimation direction="top" delay={0.5}>
            <h3 className="max-w-[249px] sm:mx-auto mb-3 lg:text-2xl lg:mx-auto">
              Projets en cours
            </h3>
            <h2 className="max-w-[290px] sm:mx-auto sm:max-w-[578px] lg:max-w-[794px] lg:text-[55px] lg:leading-[70px] lg:mx-auto">
              Une collaboration basée sur la passion pour l’innovation
            </h2>
          </ScrollAnimation>
        </div>
        {/* div main images */}
        <div className="flex flex-col mx-12 space-y-6 md:max-w-full md:mx-auto md:flex-row md:space-y-0 sm:flex-wrap md:justify-center md:px-10 md:gap-6 lg:gap-7">
          {/* div 1 block images */}
          <ScrollAnimation direction="right" delay={0.5}>
            <img width={261} height={147} src={Eurovia} alt="logo eurovia" />
          </ScrollAnimation>
          <ScrollAnimation direction="bottom" delay={1}>
            <img width={261} height={147} src={Hermes} alt="logo hermes" />
          </ScrollAnimation>
          <ScrollAnimation direction="top" delay={1.5}>
            <img
              width={261}
              height={147}
              src={IdelExpert}
              alt="logo idel expert"
            />
          </ScrollAnimation>
          <ScrollAnimation direction="left" delay={2}>
            <img
              width={261}
              height={147}
              src={MadocSante}
              alt="logo madoc sante"
            />
          </ScrollAnimation>
          <ScrollAnimation direction="right" delay={2.5}>
            <img width={261} height={147} src={CfaSante} alt="logo cfa sante" />
          </ScrollAnimation>
          <ScrollAnimation direction="top" delay={3}>
            <img width={261} height={147} src={Bimini} alt="logo bimini" />
          </ScrollAnimation>
          <ScrollAnimation direction="left" delay={3.5}>
            <img width={261} height={147} src={Gaby} alt="logo gaby" />
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
};

export default CollabHome;
